import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  CardGiftcard,
  LocalAtm,
  Dehaze,
  Groups,
  Person,
} from "@mui/icons-material";
import {
  Box,
  useMediaQuery,
  useTheme,
  AppBar,
  BottomNavigation,
  BottomNavigationAction, Grid, Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { selectCurrentToken } from "../features/slices/authSlice";
import { selectAlertIsOpen } from "../features/slices/alertSlice";

import { useGetCommonBackgroundQuery } from "../features/api/publicApiSlice";

import DesktopHeader from "./Header/DesktopHeader";
import MobileHeader from "./Header/MobileHeader";
import Footer from "./Footer";
import SideNav from "./common/SideNav";
import SnackbarAlert from "./common/SnackbarAlert";
import * as Constant from "../features/constant";
import Drawer from "./common/Drawer";
import { useGetProfileQuery } from "../features/api/userApiSlice";
import SpinWheelSideNavBar from "../components/common/SpinWheelSideNavBar";
import { SvgIcon } from "@mui/material";

const Layout = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const token = useSelector(selectCurrentToken);
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const alertIsOpen = useSelector(selectAlertIsOpen);
  const [showPopup, setShowPopup] = useState(true);

  const {
    data: commonBackground,
    isLoading: isCommonBackgroundLoading,
    isSuccess: isCommonBackgroundSuccess,
  } = useGetCommonBackgroundQuery({ prefetch: true });

  const handleClose = () => {
    setShowPopup(false);
  };

  const triggerLiveChat = () => {
    if (
      typeof window.LiveChatWidget !== "undefined" &&
      window.LiveChatWidget.call
    ) {
      window.LiveChatWidget.call("maximize");
    }
  };

  const {
    data: user,
    isFetching: isUserFetching,
    isLoading: isUserLoading,
  } = useGetProfileQuery({ prefetch: true });

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleButtonClick = () => {
    setIsDrawerOpen(true); // Always open the drawer
  };

  const drawerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setIsDrawerOpen(false);
      }
    };

    if (isDrawerOpen) {
      setTimeout(() => {
        document.addEventListener("click", handleClickOutside);
      }, 100);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isDrawerOpen]);

  const ThinDehaze = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" strokeWidth="1.0" />
    </SvgIcon>
  );
  return (

    <Box
      display="flex"
      flexDirection="column"
      backgroundColor={theme.palette.background.secondaryPaper}
      minHeight="100vh"
    >
      {alertIsOpen && <SnackbarAlert />}
      {<SideNav />}
      {process.env.REACT_APP_SHOW_SPINWHEEL === 'true' && <SpinWheelSideNavBar />}
      {/*<div>*/}
      {/*  <Grid container>*/}
      {/*    <Grid item style={{*/}
      {/*      display: showPopup ? 'flex' : 'none',*/}
      {/*      flexDirection: 'row',*/}
      {/*      alignItems: 'center',*/}
      {/*      justifyContent: 'center',*/}
      {/*      backgroundColor: '#ee2842',*/}
      {/*      position: 'fixed',*/}
      {/*      top: 0,*/}
      {/*      left: 0,*/}
      {/*      width: '100%',*/}
      {/*      padding: '3px',*/}
      {/*      zIndex: 9999, // Ensure the popup appears above other content*/}
      {/*      textAlign: 'center',*/}
      {/*    }}>*/}
      {/*      <Typography style={{*/}
      {/*        color: 'white',*/}
      {/*        position: 'relative',*/}
      {/*        zIndex: 1,*/}
      {/*        fontSize: '10px',*/}
      {/*        marginRight: '5px',*/}
      {/*        fontWeight: 'bold',*/}
      {/*      }}>*/}
      {/*        {t("header.desc")}*/}
      {/*      </Typography>*/}
      {/*      <button style={{*/}
      {/*        background: theme.palette.button.secondary.main,*/}
      {/*        color: 'white',*/}
      {/*        width: '80px',*/}
      {/*        height: '24px',*/}
      {/*        bottom: '5px',*/}
      {/*        marginRight: '25px',*/}
      {/*        borderRadius: '5px', // Add border-radius for curved corners*/}
      {/*        borderColor: 'transparent',*/}
      {/*        zIndex: 0,*/}
      {/*        fontSize: '10px',*/}
      {/*        fontWeight: 'bold',*/}
      {/*      }}*/}
      {/*              onClick={handleButtonClick}*/}
      {/*      >*/}
      {/*        {t("header.button")}*/}
      {/*      </button>*/}
      {/*      <button style={{*/}
      {/*        border: 'none',*/}
      {/*        background: 'none',*/}
      {/*        cursor: 'pointer',*/}
      {/*        color: 'white',*/}
      {/*        position: 'absolute',*/}
      {/*        top: '10px',*/}
      {/*        right: '5px',*/}
      {/*        fontWeight: 'bold',*/}
      {/*        fontSize: '12px',*/}
      {/*      }} onClick={handleClose}>X*/}
      {/*      </button>*/}
      {/*    </Grid>*/}
      {/*  </Grid>*/}
      {/*</div>*/}
      <header>
        {mobileView ? (
          <>
            <MobileHeader
              background={
                commonBackground?.mobileBackground[0]?.thumbnailUrl
              }
            />
          </>
        ) : (
          <DesktopHeader
            background={commonBackground?.webBackground[0]?.thumbnailUrl}
          />
        )}
      </header>
      <Box flex={1}>
        <Outlet />
      </Box>
      {!mobileView && (
        <footer>
          <Footer
            background={commonBackground?.webBackground[1]?.thumbnailUrl}
            contactDetails={commonBackground?.result}
          />
        </footer>
      )}

      {mobileView && (
        <AppBar
          position="fixed"
          style={{
            top: "auto",
            bottom: 0,
          }}
        >
          <BottomNavigation
            sx={{
              backgroundColor: theme.palette.bottomNav,
            }}
            showLabels
            // value={value}
            onChange={(event, newValue) => {
              if (newValue === 0) {
                setIsDrawerOpen(true);
              } else {
                const showReferral = process.env.REACT_APP_SHOW_REFERRAL === 'true';
                const adjustedIndex = showReferral ? newValue : newValue;

                switch (adjustedIndex) {
                  case 1:
                    const affiliateSite = process.env.REACT_APP_AFFILIATE_SITE;

                    if (affiliateSite) {
                      window.open(affiliateSite, '_blank');
                    } else {
                      if (token) {
                        navigate(Constant.getPath("/affiliate"), {
                          state: {
                            screen: "Affiliate",
                          }
                        });
                      } else {
                        navigate(Constant.getPath("/login"));
                      }
                    }
                    break;
                  case 2:
                    if (token) {
                      navigate(Constant.getPath("/profileWallet"), {
                        state: {
                          screen: "Deposit",
                        },
                      });
                    } else {
                      navigate(Constant.getPath("/login"));
                    }
                    break;
                  case 3:
                    if (token) {
                      navigate(Constant.getPath("/promocenter"), {
                        state: {
                          isNotProfileWallet: true,
                        },
                      });
                    } else {
                      navigate(Constant.getPath("/promotion"));
                    }
                    break;
                  case 4:
                    if (token) {
                      navigate(Constant.getPath("/profileWallet"));
                    } else {
                      navigate(Constant.getPath("/login"));
                    }
                    break;
                }
              }
            }}
          >
            <BottomNavigationAction
              sx={{
                color: process.env.REACT_APP_COLOR_MOBILELAYOUT_TEXT || "white", "& .MuiSvgIcon-root": { color: theme.palette.bottomNavIcon, fontSize: "28px", },
                width: "20%",
                minWidth: "20%",
                maxWidth: "20%"
              }}
              label={t("footer.menu")}
              icon={process.env.REACT_APP_BOTTOMNAV_USE_THIN_DEHAZE === 'true' && <ThinDehaze /> || <Dehaze />}
              onClick={handleButtonClick}
            />
            {process.env.REACT_APP_SHOW_REFERRAL === 'true' && (
              <BottomNavigationAction
                sx={{
                  color: process.env.REACT_APP_COLOR_MOBILELAYOUT_TEXT || "white", "& .MuiSvgIcon-root": { color: theme.palette.bottomNavIcon },
                  width: "20%",
                  minWidth: "20%",
                  maxWidth: "20%"
                }}
                label={t("footer.affiliate")}
                icon={
                  process.env.REACT_APP_BOTTOMNAV_REFERRAL ? (
                    <img
                      src={process.env.REACT_APP_BOTTOMNAV_REFERRAL}
                      alt="Referral Icon"
                      style={{ width: 30, height: 30 }}
                    />
                  ) : (
                    <Groups />
                  )
                }
              />
            )}
            <BottomNavigationAction
              sx={{
                color: process.env.REACT_APP_COLOR_MOBILELAYOUT_TEXT || "white", "& .MuiSvgIcon-root": { color: theme.palette.bottomNavIcon },
                width: "20%",
                minWidth: "20%",
                maxWidth: "20%"
              }}
              label={t("footer.deposit")}
              icon={
                process.env.REACT_APP_BOTTOMNAV_DEPOSIT ? (
                  <img
                    src={process.env.REACT_APP_BOTTOMNAV_DEPOSIT}
                    alt="Deposit Icon"
                    style={{ width: 30, height: 30 }}
                  />
                ) : (
                  <LocalAtm />
                )
              }
            />
            <BottomNavigationAction
              sx={{
                color: process.env.REACT_APP_COLOR_MOBILELAYOUT_TEXT || "white", "& .MuiSvgIcon-root": { color: theme.palette.bottomNavIcon },
                width: "20%",
                minWidth: "20%",
                maxWidth: "20%"
              }}
              label={t("footer.promotion")}
              icon={
                process.env.REACT_APP_BOTTOMNAV_PROMOTION ? (
                  <img
                    src={process.env.REACT_APP_BOTTOMNAV_PROMOTION}
                    alt="Promotion Icon"
                    style={{ width: 30, height: 30 }}
                  />
                ) : (
                  <CardGiftcard />
                )
              }
            />
            <BottomNavigationAction
              sx={{
                color: process.env.REACT_APP_COLOR_MOBILELAYOUT_TEXT || "white", "& .MuiSvgIcon-root": { color: theme.palette.bottomNavIcon },
                width: "20%",
                minWidth: "20%",
                maxWidth: "20%"
              }}
              label={t("footer.account")}
              icon={
                process.env.REACT_APP_BOTTOMNAV_ACCOUNT ? (
                  <img
                    src={process.env.REACT_APP_BOTTOMNAV_ACCOUNT}
                    alt="Account Icon"
                    style={{ width: 30, height: 30 }}
                  />
                ) : (
                  <Person />
                )
              }
            />
          </BottomNavigation>

          {isDrawerOpen && (
            <div ref={drawerRef} className="drawer-container">
              <Drawer user={user?.result} />
            </div>
          )}

        </AppBar>
      )}
    </Box>
  );
};

export default Layout;
